export default class CheckoutSettings {
    public orderUrl: string;
    public subscriptionUrl: string;
    constructor(settings: any) {
        this.orderUrl = settings.orderUrl;
        this.subscriptionUrl = settings.subscriptionUrl;
    }
}